import React from "react";
import {FormControlLabel,Switch} from "@material-ui/core";
const SwitchMod = (props) =>{
    const {Estatus, Id, Name, onChangeSwitch} = props;
    const handlerSwitchChange = (event) =>{
        onChangeSwitch(event.target.value, event.target.checked);
    }
    return (
        <FormControlLabel
        control={<Switch checked={Estatus} onChange={handlerSwitchChange} value={Id}  name={Name} />}
        label={Estatus  ? 'Activo' : 'Inactivo'}
        />
    )
}
export default SwitchMod;